<div class="headers-details" [ngClass]="screenClasses()">
  <div class="avatar">
    <on-ui-cover [cover]="cover"></on-ui-cover>
  </div>
  <div class="info">
    <div class="name">{{ title }}</div>
    <div class="rating">
      <app-rating [stats]="school"></app-rating>
      <div class="school-participants" *ngIf="statsStudentsCount">
        {{'user-profile.teacher-stat.students' | translate}}: {{ statsStudentsCount }}
      </div>
    </div>
  </div>
</div>
